<template>
    <!-- <div class="container"> -->
        <!-- <div class="data" style="display: flex;"> -->
            <!-- @mouseenter="isShow = true" @mouseleave="isShow = false" -->
            <div class="search-date-range">
                <el-date-picker v-model="date" type="daterange" range-separator="-" start-placeholder="年/月/日"
                    style="width:100%" end-placeholder="年/月/日" @change="onChangeDate" value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy/MM/dd" :default-time="['00:00:00', '23:59:59']" :picker-options="pickerOptions"
                    clearable prefix-icon="el-icon-date">
                </el-date-picker>

                
                <!-- <div class="line"></div> -->
                <!-- <div class="close" v-if="isShow && date && date.length != 0" @click="clearDate">
                    <i class="el-icon-circle-close"></i>
                </div>
                <div class="showCalendar">
                    <i class="el-icon-date"></i>
                </div> -->

            </div>
            <!-- <el-date-picker v-model="date" type="daterange" unlink-panels clearable :append-to-body="false"
                style="width: 346px;" popper-class="sift-data" range-separator="-" start-placeholder="请选择年/月/日"
                end-placeholder="请选择年/月/日" format="yyyy-MM-dd" @change="onChangeDate" value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']">
                >
            </el-date-picker>
            <div class="showCalendar">
                <i class="el-icon-date"></i>
            </div> -->
        <!-- </div> -->
    <!-- </div> -->
</template>
<script>
export default {
    name: 'elDate',
    props: {
        dateData: Array,
        defaultDays: {
            type: Number,
            default: null,
        },
        maxRangeDays: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            date: [],
            pickerOptions: {
                disabledDate: (time) => {
                    if (!this.maxRangeDays || !this.date || this.date.length === 0) {
                        return false
                    }
                    const start = new Date(this.date[0].replace(' ', 'T'))
                    if (!this.date[1]) {
                        const minDate = new Date(start)
                        minDate.setDate(start.getDate() - this.maxRangeDays)
                        const maxDate = new Date(start)
                        maxDate.setDate(start.getDate() + this.maxRangeDays)
                        return time.getTime() < minDate.getTime() || time.getTime() > maxDate.getTime()
                    }
                    const end = new Date(this.date[1].replace(' ', 'T'))
                    const diffDays = Math.abs((end - start) / (1000 * 60 * 60 * 24))
                    return diffDays > this.maxRangeDays
                }
            },
            // showCalendar: true,
            // value1: [],
            // isShow: false,
        }
    },
    created() {
        // console.log(this.dateData)
        this.date = this.dateData || []
    },
    watch: {
        dateData: {
            immediate: true,
            handler(val) {
                this.date = Array.isArray(val) ? val : []
            }
        }
    },
    mounted() {

    },
    methods: {
        // clearDate() {
        //     this.date = []
        //     this.$emit('changeData', this.date)
        // },
        formatDate(date) {
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            return `${year}-${month}-${day} 00:00:00`
        },
        onChangeDate() {
            if (!Array.isArray(this.date) || this.date.length !== 2 || !this.date[0] || !this.date[1]) {
                this.$emit('changeData', this.date || [])
                return
            }
            if (this.maxRangeDays) {
                const start = new Date(this.date[0].replace(' ', 'T'))
                const end = new Date(this.date[1].replace(' ', 'T'))
                const diffDays = Math.abs((end - start) / (1000 * 60 * 60 * 24))
                if (diffDays > this.maxRangeDays) {
                    const maxEnd = new Date(start)
                    maxEnd.setDate(start.getDate() + this.maxRangeDays)
                    this.date = [this.date[0], this.formatDate(maxEnd)]
                    this.$message.warning(`日期跨度不能超过${this.maxRangeDays}天`)
                }
            }
            this.$emit('changeData', this.date)
        }
    }
}
</script>
  
<style scoped lang="scss">
.search-date-range {
    width: 204px;
    height: 32px;
    position: relative;
    // border: 1px solid #E3E6E5;
    // border-radius: 4px;
    // box-sizing: border-box;
    // margin-top: 2px;
    /deep/ .el-range__icon {
        position: absolute;
        margin: 0;
        float: none;
        top: 0;
        right: 1px;
        line-height: 30px;
    }
    /deep/ .el-range__close-icon{
        margin-right: 10px;
    }
    // /deep/ .el-range-editor.el-input__inner,
    // /deep/ .el-range-editor.is-active {
    //     height: 32px;
    //     // border: none!important;
    //     display: flex;
    //     padding: 0!important;
    // }

    // /deep/ .el-range-editor .el-range-input {
    //     line-height: 30px;
    //     border: none;
    //     height: 30px;
    //     border-radius: 5px;
    //     // width: 128px;
    //     box-sizing: border-box;
    //     text-align: left;
    //     padding-left: 8px;
    //     // background-color: red;
    // }

    // /deep/ .el-range-editor .el-range-input:focus {
    //     line-height: 30px;
    //     border: none;
    //     height: 30px;
    //     border-radius: 5px;
    //     // width: 128px;
    //     box-sizing: border-box;
    //     text-align: left;
    //     padding-left: 8px;
    // }

    // /deep/ .el-date-editor .el-range__close-icon {
    //     margin-top: 0px;
    // }
    /deep/ .el-range-separator{
        padding: 0;
        line-height: 20px;
    }
}

// .close {
//     position: absolute;
//     top: -1px;
//     right: 26px;
//     cursor: pointer;
//     color: #C0C4CC
// }
// .showCalendar {
//     margin-left: 0px;
//     line-height: 30px;
//     position: absolute;
//     color: #C0C4CC;
//     top: 0px;
//     right: 8px;

// }




</style>